
// Haversine formula to calculate distance between two points on Earth
export const calculateDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c; // Distance in kilometers
  
  return distance;
};

export const formatDistance = (distanceKm: number, unit: 'km' | 'mi' = 'km'): string => {
  if (unit === 'mi') {
    const distanceMi = distanceKm * 0.621371;
    if (distanceMi < 0.1) {
      return `${Math.round(distanceMi * 5280)}ft away`;
    } else if (distanceMi < 10) {
      return `${distanceMi.toFixed(1)}mi away`;
    } else {
      return `${Math.round(distanceMi)}mi away`;
    }
  } else {
    if (distanceKm < 1) {
      return `${Math.round(distanceKm * 1000)}m away`;
    } else if (distanceKm < 10) {
      return `${distanceKm.toFixed(1)}km away`;
    } else {
      return `${Math.round(distanceKm)}km away`;
    }
  }
};

// Check if a location is within a certain radius
export const isWithinRadius = (
  userLat: number,
  userLon: number,
  targetLat: number,
  targetLon: number,
  radiusKm: number
): boolean => {
  const distance = calculateDistance(userLat, userLon, targetLat, targetLon);
  return distance <= radiusKm;
};
